import { jsx, jsxs } from "react/jsx-runtime";
import { Suspense, useState, useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
const ErrorBoundaryComponent = ({ children, fallbackComponent }) => /* @__PURE__ */ jsx(ErrorBoundary, { FallbackComponent: fallbackComponent, children: /* @__PURE__ */ jsx(Suspense, { fallback: fallbackComponent, children }) });
function ErrorFallback({ componentType, error, id, context }) {
  const { cmsEngineContext, additionalContext } = context;
  const { runMode } = (cmsEngineContext == null ? void 0 : cmsEngineContext.environment) || {};
  const { appEntryPoint } = (cmsEngineContext == null ? void 0 : cmsEngineContext.app) || {};
  const { previewBasePath, environmentId, spaceId, type } = (additionalContext == null ? void 0 : additionalContext.preview) || {};
  const ecmBasePath = runMode === "production" ? "https://internal.paypalinc.com/contentmanager" : "https://www.msmaster.qa.paypal.com/contentmanager";
  return /* @__PURE__ */ jsx(
    "div",
    {
      role: "alert",
      className: "error-boundary-alert",
      children: /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("p", { children: "Something went wrong while previewing this component:" }),
        /* @__PURE__ */ jsxs("pre", { children: [
          "Content Model:",
          componentType
        ] }),
        /* @__PURE__ */ jsxs("pre", { children: [
          "Entry ID:",
          id
        ] }),
        /* @__PURE__ */ jsxs("pre", { className: "error-details", children: [
          "Error Details:",
          String(error)
        ] }),
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx(
            "a",
            {
              href: `${ecmBasePath}/space/${spaceId}/environment/${environmentId}/entries/${id}`,
              target: "_blank",
              className: "ecm-btn",
              rel: "noreferrer",
              children: "Open Entry Details on ECM"
            }
          ),
          type === "page" && /* @__PURE__ */ jsx(
            "a",
            {
              href: `${appEntryPoint}${previewBasePath}/${id}`,
              target: "_blank",
              className: "ecm-btn",
              rel: "noreferrer",
              children: "Preview Entry Individually"
            }
          )
        ] })
      ] })
    }
  );
}
function Loading() {
  return /* @__PURE__ */ jsx("div", { className: "loading", children: "Loading..." });
}
const ForceClientSideRender = ({ children, fallback }) => {
  const [client, setClient] = useState(false);
  useEffect(() => {
    if (typeof document !== void 0) {
      setTimeout(() => setClient(true), 1);
    }
  }, []);
  return /* @__PURE__ */ jsx(Suspense, { fallback: fallback || /* @__PURE__ */ jsx(Loading, {}), children: client && children });
};
export {
  ErrorFallback as E,
  ForceClientSideRender as F,
  ErrorBoundaryComponent as a
};
